import React from 'react';
import DefaultWidthContainer from '../../Layout/Containers/DefaultWidthContainer';
import FullWidthContainer from '../../Layout/Containers/FullWidthContainer';
import HeadingAndTextContainer from '../../Layout/Containers/HeadingAndTextContainer/HeadingAndTextContainer';
import LargeWidthContainer from '../../Layout/Containers/LargeWidthContainer';
import ContactBannerComponent from '../../util/ContactComponent/ContactBannerComponent';
import { servicesData } from '../servicesData';
import styles from './digitalStrategy.module.scss';
import RelatedServicesComponentRender from '../../RelatedServices/RelatedServicesComponentRender';
import BreadcrumbsComponent from '../../Breadcrumbs/BreadcrumbsComponent';

const crumbs = [
    {
        url: '/services',
        name: 'Services',
    },
    {
        url: '/services/digital-strategy',
        name: 'Digital Strategy',
    },
];

const DigitalStrategyComponent = () => (
    <>
        <DefaultWidthContainer>
            <BreadcrumbsComponent crumbs={crumbs} />
        </DefaultWidthContainer>
        <FullWidthContainer>
            <HeadingAndTextContainer
                ingress="Digital Strategy"
                ingressSize="big"
                h1={true}
                paragraphSize="big"
            >
                <p>
                    Noria helps define your digital ambitions, establish a clear target state and
                    build an actionable roadmap to get there. Our highly experienced consultants
                    enable your organisation to increase the speed of technology delivery in
                    financial services.
                </p>
            </HeadingAndTextContainer>
        </FullWidthContainer>
        <LargeWidthContainer>
            <div className={styles.illustration}>
                <img
                    src="/images/services/digital-strategy.png"
                    alt="Digital Strategy"
                    width="80%"
                />
            </div>
        </LargeWidthContainer>
        <FullWidthContainer>
            <HeadingAndTextContainer
                ingress="Our Digital Strategy advisory services include:"
                ingressSize="small"
                h1={true}
                paragraphSize="small"
                extraClassNames={styles.servicesIncluded}
            >
                <ul>
                    <li>Current state assessment and gap analysis</li>
                    <li>Target state development</li>
                    <li>IT strategy/change roadmap</li>
                    <li>Organisational agility review</li>
                    <li>Business architecture review</li>
                    <li>IT sourcing advisory</li>
                </ul>
            </HeadingAndTextContainer>
        </FullWidthContainer>
        <DefaultWidthContainer>
            <RelatedServicesComponentRender
                services={servicesData}
                currentServiceKey={'DIGITAL_STRATEGY'}
            ></RelatedServicesComponentRender>
        </DefaultWidthContainer>
        <ContactBannerComponent
            heading={'Questions about Digital Strategy?'}
            isReadyForDemo={false}
        >
            {
                <>
                    <div>
                        <p>Arne Andreas Gjølme</p>
                        <a href="mailto:arne.andreas.gjolme@noria.no?subject=Queries/Demo – Digital Strategy&body=Hi, Arne Andreas">
                            Contact Arne Andreas
                        </a>
                    </div>
                    <div>
                        <p>Hugo Sundkjaer</p>
                        <a href="mailto:hugo.sundkjer@noria.no?subject=Queries/Demo – Digital Strategy&body=Hi, Hugo Sundkjaer">
                            Contact Hugo Sundkjaer
                        </a>
                    </div>
                </>
            }
        </ContactBannerComponent>
    </>
);

export default DigitalStrategyComponent;
